/**
 * CCNP ENCOR 350-401 Domain Taxonomy
 *
 * All four apps reference this shared domain structure for consistent
 * categorization, coloring, and exam-weight calculations.
 *
 * Based on Cisco's official ENCOR 350-401 v1.1 exam blueprint.
 */

export const DOMAINS = [
  { id: '1.0', name: 'Architecture',      weight: 0.15, color: '#4A90D9', shortName: 'ARCH' },
  { id: '2.0', name: 'Virtualization',    weight: 0.10, color: '#7B68EE', shortName: 'VIRT' },
  { id: '3.0', name: 'Infrastructure',    weight: 0.30, color: '#2ECC71', shortName: 'INFRA' },
  { id: '4.0', name: 'Network Assurance', weight: 0.10, color: '#F39C12', shortName: 'ASSUR' },
  { id: '5.0', name: 'Security',          weight: 0.20, color: '#E74C3C', shortName: 'SEC' },
  { id: '6.0', name: 'Automation',        weight: 0.15, color: '#1ABC9C', shortName: 'AUTO' },
];

export const DOMAIN_MAP = Object.fromEntries(DOMAINS.map(d => [d.id, d]));

export const PASSING_SCORE = 825; // out of 1000
export const EXAM_QUESTION_COUNT = 102;
export const EXAM_DURATION_MINUTES = 120;

export const getDomainById = (id) => DOMAIN_MAP[id] || null;
export const getDomainColor = (id) => DOMAIN_MAP[id]?.color || '#888';
export const getDomainName = (id) => DOMAIN_MAP[id]?.name || 'Unknown';
